import React from 'react';
import cambrian from '../../assets/images/Education/Cambrianlogo.png';
import greenUni from '../../assets/images/Education/green-uni.png';

const educationData = [
   {
      id: 1,
      degree: 'Bachelor of Computer Science',
      image: greenUni,
      institution: 'Green University',
      duration: 'Jan 2019 — July 2023',
      tag: 'B.Sc.',
   },
   {
      id: 2,
      degree: 'HSC in Science',
      image: cambrian,
      institution: 'Cambrian College',
      duration: 'Jan 2016 — April 2018',
      tag: 'HSC',
   },
];

const Education = () => {
   return (
      <>
         {educationData.map(({ id, degree, image, institution, duration, tag }) => (
            <div key={id} className="glass-card hover-card p-4 flex items-center gap-4">
               <div className="grid place-items-center h-14 w-14 shrink-0 rounded-xl bg-zinc-100 dark:bg-zinc-800 ring-1 ring-zinc-200/70 dark:ring-zinc-700/70 overflow-hidden">
                  <img src={image} className="h-10 w-10 object-contain" alt={institution} />
               </div>
               <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                     <span className="inline-flex items-center rounded-full bg-brand-500/10 px-2 py-0.5 text-[10px] font-bold tracking-wider text-brand-600 dark:text-brand-400 ring-1 ring-brand-500/20">
                        {tag}
                     </span>
                     <span className="text-[11px] font-mono text-zinc-500 dark:text-zinc-400 truncate">{duration}</span>
                  </div>
                  <p className="mt-1 font-display font-bold text-[15px] leading-tight truncate">{degree}</p>
                  <p className="text-[12.5px] font-semibold text-brand-600 dark:text-brand-400 truncate">{institution}</p>
               </div>
            </div>
         ))}
      </>
   );
};

export default Education;
